// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUpComponent_signUpContainer__24W89","signInLinkContainer":"SignUpComponent_signInLinkContainer__1On0-"};